import { Component, inject } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { Dipendente } from 'src/app/models/dipendente';
import { Articoli } from 'src/app/models/articoli';
import { DettaglioArticoloDipendenteService } from 'src/app/shared/services/dettaglio-articolo-dipendente.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import {
  DxiColumnComponent,
  DxiItemComponent,
  DxoEditingComponent,
  DxoFilterRowComponent,
  DxoFormComponent,
  DxoGroupingComponent,
  DxoGroupPanelComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoPopupComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-gestione-cope-dpi-dettagli',
  templateUrl: './gestione-cope-dpi-dettagli.component.html',
  imports: [
    DxDataGridComponent,
    DxiColumnComponent,
    DxoLookupComponent,
    DxiItemComponent,
    DxoFormComponent,
    DxoPopupComponent,
    DxoTextsComponent,
    DxoEditingComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoGroupingComponent,
    DxoGroupPanelComponent,
  ],
  standalone: true,
})
export class GestioneCopeDpiDettagliComponent {
  private dipService = inject(DipendentiService);
  private articoliService = inject(ArticoliService);
  private dettService = inject(DettaglioArticoloDipendenteService);

  dataSource: any;
  listDip: Dipendente[] = [];
  listArticoli: Articoli[] = [];

  constructor() {
    this.dipService.listTemp().subscribe((dati) => {
      this.listDip = dati;
      console.log(dati);
    });
    this.articoliService.listTemp().subscribe((articoli) => {
      this.listArticoli = articoli.filter(x => x.attivo == true);
      console.log(articoli);
    });
    this.dataSource = new CustomStore({
      key: ['idDpi', 'codcope'],
      load: () => {
        return firstValueFrom(this.dettService.list())
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      byKey: (values) => {
        return firstValueFrom(
          this.dettService.get(values.idDpi, values.codcope),
        ).catch(() => {
          throw 'Get by key failed';
        });
      },
      insert: (values) => {
        return firstValueFrom(this.dettService.insert(values)).catch(() => {
          throw 'Insertion failed';
        });
      },
      remove: (values) => {
        return firstValueFrom(
          this.dettService.remove(values.idDpi, values.codcope),
        )
          .then(() => console.log('delete eseguito'))
          .catch(() => {
            throw 'Deletion failed';
          });
      },
      update: (key, values) => {
        return firstValueFrom(
          this.dettService.update(key.idDpi, key.codcope, values),
        ).catch(() => {
          throw 'Update failed';
        });
      },
    });
  }

  getArticoloDisplayExpr(item: Articoli) {
    if (!item) {
      return '';
    }

    return (
      item.codice +
      ' - ' +
      item.descrizione +
      (item.taglia ? ' - ' + item.taglia : '')
    );
  }
}
